import React, { useState } from "react";

import { ListItemIcon, MenuItem, Typography, Button, Box } from "@mui/material";
import { Logout, MoreHoriz } from "@mui/icons-material";

import { colors } from "../../colors";
import { imagenes } from "../../../helpers/imagenes";
import { Menu_items } from "./Menu_items";

import "./navbar.css";
import { List_options } from "./List_options";
import { NavLink } from "react-router-dom";
import { logout } from "../../../helpers/auth";

export const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const menu = [
    {
      key: "acolitos",
      label: "Acólitos",
      options: [
        {
          goto: "acolitos",
          label: "Acólitos",
        },
        {
          goto: "acolitos/nuevo",
          label: "Nuevo acólito",
        },
        {
          goto: "acolitos/ausencias",
          label: "Ausencias",
        },
      ],
    },
    {
      key: "ceremonias",
      label: "Ceremonias",
      options: [
        {
          goto: "ceremonias",
          label: "Ceremonias",
        },
        {
          goto: "ceremonias/nueva",
          label: "Nueva ceremonia",
        },
      ],
    },
    {
      key: "equipos",
      label: "Equipos",
      options: [
        {
          goto: "equipos",
          label: "Equipos",
        },
        {
          goto: "equipos/nuevo",
          label: "Nuevo equipo",
        },
      ],
    },
    {
      key: "asistencias",
      label: "Asistencias",
      options: [
        {
          goto: "asistencias",
          label: "Ver asistencias",
        },
      ],
    },
  ];

  return (
    <>
      <div className="navBar" style={styles.navbar}>
        <div className="div_logo">
          <img
            src={imagenes("./medalla/Medalla_transparente_roja.png")}
            alt="medalla"
            className="navBar_logo"
          />
        </div>
        <div className="text_bienvenido">
          <Typography variant="h4" fontWeight={700}>
            Bienvenido
          </Typography>
        </div>
        <ul className="menu_items_ul">
          {menu.map((item) => (
            <Menu_items
              key={item.label}
              label={item.label}
              to={item.key}
              options={item.options}
            />
          ))}
        </ul>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px 20px",
            borderRadius: 10,
            // cursor: "pointer",
          }}
        >
          <MoreHoriz className="pic" onClick={handleClick} />
        </Box>
        <div className="div_account">
          <NavLink
            // key={option.label}
            to={"/enviar-rol"}
          >
            <Button
              sx={{
                backgroundColor: colors.primary,
                color: "white",
                fontWeight: 700,
                borderRadius: 10,
                padding: "10px 20px",
                fontSize: 15,
              }}
            >
              Enviar rol de acólitos
            </Button>
          </NavLink>
          {/* <div className="name">
          <Typography variant="h5" fontWeight={500}>
            Eduardo Manuel Ojeda Galván
          </Typography>
          <Typography
            variant="h6"
            fontWeight={300}
            color="secondary"
            className="cargo"
          >
            Presidente
          </Typography>
        </div>
        <div className="div_pic">
          <Avatar
            alt="profile_pic"
            sx={{
              width: width_screen > 500 ? 70 : 50,
              height: width_screen > 500 ? 70 : 50,
              fontSize: width_screen > 500 ? 30 : 20,
            }}
            className="pic"
            onClick={handleClick}
          >
            EO
          </Avatar>
        </div> */}
        </div>
        <List_options anchorEl={anchorEl} open={open} handleClose={handleClose}>
          {/* <MenuItem onClick={handleClose}>
            <Avatar />
            Mi cuenta
          </MenuItem> */}
          <MenuItem onClick={logout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Cerrar sesión
          </MenuItem>
        </List_options>
      </div>
      <div
        // Usar este div para que el contenido no se oculte por el navbar
        style={{
          // height: height_screen,
          backgroundColor: "white",
          paddingBottom: 140,
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 50,
        }}
      ></div>
      <div
        style={{
          marginBottom: 160,
        }}
      ></div>
    </>
  );
};

const styles = {
  navbar: {
    backgroundColor: colors.gray_light,
    color: colors.primary,
    //Mostrar el navbar en todo momento
    position: "fixed",
    top: 0,
    left: 0,
    width: "98%",
    // display: "flex",
    // justifyContent: "space-between",
    // alignItems: "center",
    // padding: "10px 20px",
    zIndex: 100,
  },
};
